/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MobileDataInNotification {
  actionText?: string;
  deepLink?: string;
}

export interface MobileDataInNotificationDto {
  actionText?: string;
  deepLink?: string;
}

export interface Notification {
  /** @format uuid */
  id?: string;
  userId: string;

  /** @format date-time */
  creationDateTime?: string;
  isViewed?: boolean;
  title: string;
  description: string;
  mobileData?: MobileDataInNotification;
}

export interface NotificationDto {
  /** @format uuid */
  id?: string;
  title?: string;
  description?: string;

  /** @format date-time */
  dateTime?: string;
  isViewed?: boolean;
  mobileData?: MobileDataInNotificationDto;
}

export interface NotificationDtoPaginationResponse {
  /** @format int32 */
  totalCount?: number;
  items?: NotificationDto[];
}

export interface PaginationRequest {
  /** @format int32 */
  pageSize?: number;

  /** @format int32 */
  pageNumber?: number;
}

export interface RegistrationTokenDto {
  token?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.instance.defaults.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      formData.append(
        key,
        property instanceof Blob
          ? property
          : typeof property === "object" && property !== null
          ? JSON.stringify(property)
          : `${property}`,
      );
      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = (format && this.format) || void 0;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      requestParams.headers.common = { Accept: "*/*" };
      requestParams.headers.post = {};
      requestParams.headers.put = {};

      body = this.createFormData(body as Record<string, unknown>);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Actonica.DrivingSchool.Notifications
 * @version v1
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  dev = {
    /**
     * No description
     *
     * @tags Dev
     * @name ResendPushList
     * @request GET:/Dev/ResendPush
     */
    resendPushList: (query?: { id?: string }, params: RequestParams = {}) =>
      this.http.request<Notification, any>({
        path: `/Dev/ResendPush`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notification
     * @name AddRegistrationTokenCreate
     * @request POST:/Notification/AddRegistrationToken
     */
    addRegistrationTokenCreate: (body: RegistrationTokenDto, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/Notification/AddRegistrationToken`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name LogInFirebaseTokenCreate
     * @request POST:/Notification/LogInFirebaseToken
     */
    logInFirebaseTokenCreate: (body: RegistrationTokenDto, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/Notification/LogInFirebaseToken`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name LogOutFirebaseTokenCreate
     * @request POST:/Notification/LogOutFirebaseToken
     */
    logOutFirebaseTokenCreate: (body: RegistrationTokenDto, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/Notification/LogOutFirebaseToken`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name GetUnreadNotificationsCountList
     * @request GET:/Notification/GetUnreadNotificationsCount
     */
    getUnreadNotificationsCountList: (params: RequestParams = {}) =>
      this.http.request<number, any>({
        path: `/Notification/GetUnreadNotificationsCount`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name GetNotificationsList
     * @request GET:/Notification/GetNotifications
     */
    getNotificationsList: (params: RequestParams = {}) =>
      this.http.request<NotificationDto[], any>({
        path: `/Notification/GetNotifications`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name GetNotificationsCreate
     * @request POST:/Notification/GetNotifications
     */
    getNotificationsCreate: (body: PaginationRequest, params: RequestParams = {}) =>
      this.http.request<NotificationDtoPaginationResponse, any>({
        path: `/Notification/GetNotifications`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name ReadNotificationCreate
     * @request POST:/Notification/ReadNotification
     */
    readNotificationCreate: (body: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/Notification/ReadNotification`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name ReadNotificationsCreate
     * @request POST:/Notification/ReadNotifications
     */
    readNotificationsCreate: (body: string[], params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/Notification/ReadNotifications`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name ReadAllNotificationsCreate
     * @request POST:/Notification/ReadAllNotifications
     */
    readAllNotificationsCreate: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/Notification/ReadAllNotifications`,
        method: "POST",
        ...params,
      }),
  };
}
